import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import Slider from "react-slick";
import { Header } from "../Header";
import { Footer } from "../Footer";
import { ReactDialogBox } from "react-js-dialog-box";
import generatePDF from "./PDFscore";
import "react-js-dialog-box/dist/index.css";
import "../assets/ohs/admin.css";
import "../assets/ohs/manual.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
export const Mannual = () => {
  const inputRef = useRef(null);
  const second = useRef();
  const third = useRef();
  const forth = useRef();
  const fifth = useRef();
  const sixth = useRef();
  const st2 = useRef();
  const { id } = useParams();
  const changeFavicon = (url) => {
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.href = url;
    }
  };
  const [name_9, setname_9] = useState(false);
  const [closeBox, setcloseBox] = useState(true);
  const [PdfcardImg, setPdfcardImg] = useState("");
  const [scoreCard, setscoreCard] = useState("");

  //Lesson 1
  const [lesson1, setlesson1] = useState(true);
  const [istruefalse_1, setistruefalse_1] = useState(false);
  const [strokeDashArray_less1, setstrokeDashArray_less1] = useState(false);
  //Lesson 1

  //Lesson 2
  const [lesson2, setlesson2] = useState(false);
  const [istruefalse_2, setistruefalse_2] = useState(false);
  const [strokeDashArray_less2, setstrokeDashArray_less2] = useState(false);
  //Lesson 2

  //Lesson 3
  const [Tab33_1, setTab33_1] = useState("Tab1");
  const [Tab33_2, setTab33_2] = useState(false);
  const [lesson3, setlesson3] = useState(false);
  const [istruefalse_3, setistruefalse_3] = useState(false);
  const [strokeDashArray_less3, setstrokeDashArray_less3] = useState(false);
  const [section3_content, setsection3_content] = useState(false);
  const [dot1, setdot1] = useState(false);
  const [dot2, setdot2] = useState(false);
  const [dot3, setdot3] = useState(false);
  const [param_title3, setparam_title3] = useState("");
  const [title3, settitle3] = useState("");
  const [param3, setparam3] = useState("");
  //Lesson 3

  //Lesson 4
  const [lesson4, setlesson4] = useState(false);
  const [istruefalse_4, setistruefalse_4] = useState(false);
  const [strokeDashArray_less4, setstrokeDashArray_less4] = useState(false);
  //Lesson 4

  //Lesson 5
  const [lesson5, setlesson5] = useState(false);
  const [istruefalse_5, setistruefalse_5] = useState(false);
  const [strokeDashArray_less5, setstrokeDashArray_less5] = useState(false);
  //Lesson 5

  //Lesson 6
  const [lesson6, setlesson6] = useState(false);
  const [istruefalse_6, setistruefalse_6] = useState(false);
  const [strokeDashArray_less6, setstrokeDashArray_less6] = useState(false);
  //Lesson 6

  //Lesson 9 Start
  const [leftmenu_bar, setleftmenu_bar] = useState(0);
  const [barwidth, setbarwidth] = useState(0);
  const [lesson9, setlesson9] = useState(false);
  const [sec_1, setsec_1] = useState(true);
  const [quizless_9_1, setquizless_9_1] = useState(false);
  const [quizless_9_2, setquizless_9_2] = useState(false);
  const [quizless_9_3, setquizless_9_3] = useState(false);
  const [quizless_9_4, setquizless_9_4] = useState(false);
  const [quizless_9_5, setquizless_9_5] = useState(false);
  const [less_5_finresult, setless_5_finresult] = useState(false);
  const [checkQ_9_1, setcheckQ_9_1] = useState("");
  const [isfirstquiz_9_1, setisfirstquiz_9_1] = useState(false);
  const [issetQuizAns_9_1_btn, setissetQuizAns_9_1_btn] = useState(false);
  const [isOpacity_9, setisOpacity_9] = useState(false);

  const [worngansQuiz_9_1, setworngansQuiz_9_1] = useState(false);
  const [rightansQuiz_9_1, setrightansQuiz_9_1] = useState(false);
  const [q1_9_next, setq1_9_next] = useState(false);
  const [checkbtn_quiz_1_9, setcheckbtn_quiz_1_9] = useState(false);

  const [isOpacity_9_1, setisOpacity_9_1] = useState(false);
  const [checkQ_9_2, setcheckQ_9_2] = useState(false);
  const [isfirstquiz_9_2, setisfirstquiz_9_2] = useState(false);
  const [issetQuizAns_9_2_btn, setissetQuizAns_9_2_btn] = useState(false);

  const [checkbtn_quiz_2_9, setcheckbtn_quiz_2_9] = useState(false);
  const [q2_9_next, setq2_9_next] = useState(false);

  const [checkQ_9_3, setcheckQ_9_3] = useState(false);
  const [isfirstquiz_9_3, setisfirstquiz_9_3] = useState(false);
  const [issetQuizAns_9_3_btn, setissetQuizAns_9_3_btn] = useState(false);

  const [checkbtn_quiz_3_9, setcheckbtn_quiz_3_9] = useState(false);
  const [q3_9_next, setq3_9_next] = useState(false);

  const [checkQ_9_4, setcheckQ_9_4] = useState(false);
  const [isfirstquiz_9_4, setisfirstquiz_9_4] = useState(false);
  const [issetQuizAns_9_4_btn, setissetQuizAns_9_4_btn] = useState(false);

  const [checkbtn_quiz_4_9, setcheckbtn_quiz_4_9] = useState(false);
  const [q4_9_next, setq4_9_next] = useState(false);

  const [checkQ_9_5, setcheckQ_9_5] = useState(false);
  const [isfirstquiz_9_5, setisfirstquiz_9_5] = useState(false);
  const [issetQuizAns_9_5_btn, setissetQuizAns_9_5_btn] = useState(false);

  const [checkbtn_quiz_5_9, setcheckbtn_quiz_5_9] = useState(false);
  const [q5_9_next, setq5_9_next] = useState(false);
  const [score__per5, setscore__per5] = useState([]);
  const [score_5, setscore_5] = useState([]);
  const [corrScore, setcorrScore] = useState(false);
  const [strokeDashArray_less9, setStrokeDashArray_less9] = useState("");
  const [istruefalse_9, setistruefalse_9] = useState(false);
  //Lesson 9 End
  useEffect(() => {
    const userStr = JSON.parse(localStorage.getItem("users"));

    if (userStr === null) {
      window.location.href = "/login";
    }
    changeFavicon(require("../assets/admin/images/f-icon.png"));

    document.title = "Start Course";

    if (scoreCard != "") {
      pdfdataget();
      setscoreCard("");
    }
  }, [id, scoreCard, PdfcardImg]);
  function formatDate_notes() {
    const options = {
      day: "2-digit",
      month: "long", // Change to "long" for full month name
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZone: "Australia/Perth",
    };

    const date = new Date();
    return date.toLocaleDateString("en-GB", options);
  }
  //Pdf
  function getimagedata(urll) {
    let formdata = {
      url: urll,
    };
    const imgBase64 =
      "data:image/png;base64,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";
    const mainpdf = (
      <html lang="en">
        <head>
          <meta charset="utf-8" />
          <link rel="icon" href="/" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta name="theme-color" content="#000000" />
          <meta
            name="description"
            content="Web site created using create-react-app"
          />
          <link
            href="https://fonts.googleapis.com/css2?family=Great+Vibes&family=Quattrocento:wght@400;700&display=swap"
            rel="stylesheet"
          />
        </head>
        <body>
          <table
            style={{
              width: "700px",
              margin: "0 auto",
              border: "10px solid rgb(0, 74, 173)",
            }}
          >
            <tbody style={{ width: "100%" }}>
              <tr>
                <td style={{ textAlign: "center" }}>
                  <div
                    style={{
                      margin: "0 auto",
                      width: "250px",
                    }}
                  >
                    <img style={{ width: "50%" }} src={imgBase64} alt="logo" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <h1
                    style={{
                      color: "rgb(0, 74, 173)",
                      fontSize: "35px",
                      textAlign: "center",
                      padding: "0px 0px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    Certificate of Training
                  </h1>
                </td>
              </tr>
              <tr>
                <td>
                  <h2
                    style={{
                      color: "#323232",
                      fontWeight: 400,
                      fontSize: "20px",
                      textAlign: "center",
                      padding: "5px 0px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    This is to certify that
                  </h2>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <h3
                      style={{
                        color: "#323232",
                        fontWeight: 400,
                        marginTop: "30px",
                        fontSize: "20px",
                        textAlign: "center",
                        padding: "5px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      {name_9}
                    </h3>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <h2
                    style={{
                      color: "#323232",
                      fontWeight: 400,
                      marginTop: "30px",
                      fontSize: "20px",
                      textAlign: "center",
                      padding: "5px 0px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    has successfully completed training in
                  </h2>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <h3
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        fontSize: "20px",
                        textAlign: "center",
                        margin: "12px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      Manual Handling
                    </h3>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div
                    style={{
                      padding: "10px 0px",
                      marginTop: "15px",
                    }}
                  >
                    <h5
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        fontSize: "20px",
                        textAlign: "center",
                        margin: "0px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      undertaken on the date
                    </h5>
                    <h6
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        fontSize: "20px",
                        textAlign: "center",
                        margin: "0px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      {formatDate_notes()}
                    </h6>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <h2
                    style={{
                      color: "#323232",
                      fontWeight: 400,
                      fontSize: "20px",
                      textAlign: "center",
                      paddingTop: "40px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    Delivered by:
                  </h2>
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>
                  <div
                    style={{
                      margin: "0 auto",
                      width: "250px",
                      paddingBottom: "10px",
                    }}
                  >
                    <img style={{ width: "50%" }} src={imgBase64} alt="logo" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </body>
      </html>
    );
    const filenamee = "Manual Handling";

    setTimeout(() => {
      generatePDF(mainpdf, filenamee);
    }, 500);
  }
  const pdfdataget = async () => {
    const cc = await getimagedata("logo1.png");
  };
  const downloadpdf = () => {
    const userStr = JSON.parse(localStorage.getItem("users"));

    let formdata = {
      user_id: userStr[0].id,
      id: id,
      name: name_9,
    };
    console.log(formdata);
    //setscoreCard(1);

    axios
      .post("https://jlmining.app/coursepdf", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => { })
      .catch((err) => { });
    pdfdataget();
  };
  //Pdf

  //Lesson 1
  const nextStep = (event) => {
    if (event === "1") {
      setlesson1(false);
      setlesson2(true);
      setistruefalse_1(true);
      setstrokeDashArray_less1(458.36);
      setleftmenu_bar(15);
      setbarwidth(15);
      setTimeout(() => {
        st2.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "2") {
      setlesson2(false);
      setlesson3(true);
      setistruefalse_2(true);
      setstrokeDashArray_less2(458.36);
      setleftmenu_bar(30);
      setbarwidth(30);
      setTimeout(() => {
        third.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "3") {
      setlesson3(false);
      setlesson4(true);
      setistruefalse_3(true);
      setstrokeDashArray_less3(458.36);
      setleftmenu_bar(45);
      setbarwidth(45);
      setTimeout(() => {
        forth.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "4") {
      setlesson4(false);
      setlesson5(true);
      setistruefalse_4(true);
      setstrokeDashArray_less4(458.36);
      setleftmenu_bar(55);
      setbarwidth(55);
      setTimeout(() => {
        fifth.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "5") {
      setlesson5(false);
      setlesson6(true);
      setistruefalse_5(true);
      setstrokeDashArray_less5(458.36);
      setleftmenu_bar(65);
      setbarwidth(65);
      setTimeout(() => {
        sixth.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "6") {
      setlesson6(false);
      setlesson9(true);
      setistruefalse_6(true);
      setstrokeDashArray_less6(458.36);
      setleftmenu_bar(85);
      setbarwidth(85);
    }
  };
  //Lesson 1
  var settings_1 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  var settings_2 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  var settings_3 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  var settings_4 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  //Lesson9
  const entername_9 = (event) => {
    const trimmedValue = event.target.value.trim();
    if (trimmedValue === "") {
      setname_9(false);
    } else {
      setname_9(trimmedValue);
    }
  };
  const btn_entername = () => {
    if (name_9 !== false) {
      setquizless_9_1(true);
      setsec_1(false);
    }
  };
  const startQuiz_9_1 = (event) => {
    setcheckQ_9_1(event);
    setcheckbtn_quiz_1_9(true);
  };

  const startQuiz_9_2 = (event) => {
    setcheckQ_9_2(event);
    setcheckbtn_quiz_2_9(true);
  };
  const startQuiz_9_3 = (event) => {
    setcheckQ_9_3(event);
    setcheckbtn_quiz_3_9(true);
    setworngansQuiz_9_1(false);
    setrightansQuiz_9_1(false);
  };
  const startQuiz_9_4 = (event) => {
    setcheckQ_9_4(event);
    setcheckbtn_quiz_4_9(true);
    setworngansQuiz_9_1(false);
    setrightansQuiz_9_1(false);
  };
  const startQuiz_9_5 = (event) => {
    setcheckQ_9_5(event);
    setcheckbtn_quiz_5_9(true);
    setworngansQuiz_9_1(false);
    setrightansQuiz_9_1(false);
  };
  const Quiz_check_9 = (event) => {
    if (event === "1") {
      setisOpacity_9(true);
      if (checkQ_9_1 === "An employee") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_9_1(true);
        setworngansQuiz_9_1(false);
      } else {
        setworngansQuiz_9_1(true);
        setrightansQuiz_9_1(false);
      }
      setissetQuizAns_9_1_btn("An employee");
      setisfirstquiz_9_1(true);
      setq1_9_next(true);
      setcheckbtn_quiz_1_9(false);
      setcheckQ_9_1("");
      setStrokeDashArray_less9(200.39);
    }
    if (event === "2") {
      setisOpacity_9(true);
      if (checkQ_9_2 === "Large loads") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_9_1(true);
        setworngansQuiz_9_1(false);
      } else {
        setworngansQuiz_9_1(true);
        setrightansQuiz_9_1(false);
      }
      setissetQuizAns_9_2_btn("Large loads");
      setisfirstquiz_9_2(true);
      setq2_9_next(true);
      setcheckbtn_quiz_2_9(false);
      setcheckQ_9_2("");
      setStrokeDashArray_less9(300.39);
    }
    if (event === "3") {
      setisOpacity_9(true);
      if (checkQ_9_3 === "Plan and") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_9_1(true);
        setworngansQuiz_9_1(false);
      } else {
        setworngansQuiz_9_1(true);
        setrightansQuiz_9_1(false);
      }
      setissetQuizAns_9_3_btn("Plan and");
      setisfirstquiz_9_3(true);
      setq3_9_next(true);
      setcheckbtn_quiz_3_9(false);
      setcheckQ_9_3("");
      setStrokeDashArray_less9(350.39);
    }
    if (event === "4") {
      setisOpacity_9(true);
      if (checkQ_9_4 === "Assess") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_9_1(true);
        setworngansQuiz_9_1(false);
      } else {
        setworngansQuiz_9_1(true);
        setrightansQuiz_9_1(false);
      }
      setissetQuizAns_9_4_btn("Assess");
      setisfirstquiz_9_4(true);
      setq4_9_next(true);
      setcheckbtn_quiz_4_9(false);
      setcheckQ_9_4("");
      setStrokeDashArray_less9(400.39);
    }
    if (event === "5") {
      setisOpacity_9(true);
      if (checkQ_9_5 === "Keeping") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_9_1(true);
        setworngansQuiz_9_1(false);
      } else {
        setworngansQuiz_9_1(true);
        setrightansQuiz_9_1(false);
      }
      setissetQuizAns_9_5_btn("Keeping");
      setisfirstquiz_9_5(true);
      setq5_9_next(true);
      setcheckbtn_quiz_5_9(false);
      setcheckQ_9_5("");

      setistruefalse_9(true);
      setStrokeDashArray_less9(458.39);
    }
  };
  const Quiz_next_9 = (event) => {
    setworngansQuiz_9_1(false);
    setrightansQuiz_9_1(false);
    if (event === "1") {
      setquizless_9_2(true);
      setquizless_9_1(false);
      setcheckbtn_quiz_1_9(false);
    }
    if (event === "2") {
      setquizless_9_3(true);
      setquizless_9_2(false);
      setrightansQuiz_9_1(false);
      setcheckbtn_quiz_2_9(false);
    }
    if (event === "3") {
      setquizless_9_4(true);
      setquizless_9_3(false);
      setcheckbtn_quiz_3_9(false);
    }
    if (event === "4") {
      setquizless_9_5(true);
      setquizless_9_4(false);
      setcheckbtn_quiz_4_9(false);
    }
    if (event === "5") {
      setquizless_9_5(false);
      setless_5_finresult(true);
      setleftmenu_bar(100);
      setbarwidth(100);
      setleftmenu_bar(100);
      setbarwidth(100);
      const sum = score_5.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
      const sum_per = score__per5.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
      setscore_5(sum);
      setscore__per5(sum_per);
      if (sum_per >= 80) {
        setcorrScore(true);
      }
    }
  };
  const refreshbtn = (event) => {
    console.log("ss");
    setless_5_finresult(false);
    setsec_1(true);
    setname_9(false);
    setquizless_9_1(false);
    setquizless_9_2(false);
    setquizless_9_3(false);
    setquizless_9_4(false);
    setquizless_9_5(false);

    setcheckQ_9_1("");
    setisfirstquiz_9_1(false);
    setissetQuizAns_9_1_btn(false);
    setisOpacity_9(false);
    setworngansQuiz_9_1(false);
    setrightansQuiz_9_1(false);
    setq1_9_next(false);
    setcheckbtn_quiz_1_9(false);
    setisOpacity_9_1(false);
    setcheckQ_9_2(false);
    setisfirstquiz_9_2(false);
    setissetQuizAns_9_2_btn(false);
    setcheckbtn_quiz_2_9(false);
    setq2_9_next(false);
    setcheckQ_9_3(false);
    setisfirstquiz_9_3(false);
    setissetQuizAns_9_3_btn(false);
    setcheckbtn_quiz_3_9(false);
    setq3_9_next(false);
    setcheckQ_9_4(false);
    setisfirstquiz_9_4(false);
    setissetQuizAns_9_4_btn(false);
    setcheckbtn_quiz_4_9(false);
    setq4_9_next(false);
    setcheckQ_9_5(false);
    setisfirstquiz_9_5(false);
    setissetQuizAns_9_5_btn(false);
    setcheckbtn_quiz_5_9(false);
    setq5_9_next(false);
    setscore__per5([]);
    setscore_5([]);
    setcorrScore(false);
    setStrokeDashArray_less9("");
    setistruefalse_9(false);
  };
  //Lesson9
  const backlesson = (event) => {
    if (event === "2") {
      setlesson2(false);
      setlesson1(true);
    }
    if (event === "3") {
      setlesson3(false);
      setlesson2(true);
    }
    if (event === "4") {
      setlesson4(false);
      setlesson3(true);
    }
    if (event === "5") {
      setlesson5(false);
      setlesson4(true);
    }
    if (event === "6") {
      setlesson6(false);
      setlesson5(true);
    }
    if (event === "9") {
      setlesson9(false);
      setlesson6(true);
    }
  };
  const bodypart = (event) => {
    if (event === "1") {
      setdot2(false);
      setdot3(false);
      setdot1(!dot1);
      console.log(dot1);
      if (dot1 === true) {
        setsection3_content(false);
      } else {
        setsection3_content(true);
      }
      settitle3("Vertebrae");
      setparam_title3("Vertebrae");
      setparam3(
        "are the 33 individual, interlocking bones that form the spinal column. Each vertebra has three main functional components; the vertebral body for load-bearing, the vertebral arch to protect the spinal cord and transverse processes for ligament attachment. "
      );
    }
    if (event === "2") {
      setdot1(false);
      setdot3(false);
      setdot2(!dot2);
      if (dot2 === true) {
        setsection3_content(false);
      } else {
        setsection3_content(true);
      }
      settitle3("Disc");
      setparam_title3("An intervertebral ");
      setparam3(
        " (or intervertebral fibrocartilage) lies between adjacent vertebrae in the vertebral column. Each disc forms a fibrocartilaginous joint (a symphysis), to allow slight movement of the vertebrae, to act as a ligament to hold the vertebrae together, and to function as a shock absorber for the spine. "
      );
    }
    if (event === "3") {
      setdot1(false);
      setdot2(false);
      setdot3(!dot3);
      if (dot3 === true) {
        setsection3_content(false);
      } else {
        setsection3_content(true);
      }
      settitle3("Spinal Nerve");
      setparam_title3("A spinal nerve");
      setparam3(
        " is a mixed nerve, which carries motor, sensory, and autonomic signals between the spinal cord and the body. In the human body there are 31 pairs of spinal nerves, one on each side of the vertebral column. "
      );
    }
  };
  const tabReview_33 = (event) => {
    setTab33_1(false);
    setTab33_2(false);

    if (event === "Tab1") {
      setTab33_1(true);
    }

    if (event === "Tab2") {
      setTab33_2(true);
    }
  };
  const menubars = () => {
    setcloseBox(!closeBox);
  };
  return (
    <>
      <div
        className={`d-flex main-admin-block align-items-stretch mt-4 ${closeBox ? "" : "close-box"
          }`}
      >
        <div className="flex-shrink-0 side-layer">
          <div className="scroll-height">
            <div className="d-flex flex-column">
              <div className="top-title d-flex flex-column gap-5">
                <h1>Manual Handling</h1>
                <div className="d-flex flex-column gap-1">
                  <div className="progress-bar-full">
                    <div style={{ width: `${barwidth}%` }}></div>
                  </div>
                  <h4 className="pro-number">
                    <span>{leftmenu_bar}%</span> COMPLETE
                  </h4>
                </div>
              </div>

              <div className="d-flex flex-column side-navbar mt-4">
                <Link
                  to="workplace.html"
                  className="d-flex align-items-center gap-3 list-link anilink active"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Introduction</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_1 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_1 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less1 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Legislation</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_2 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_2 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less2 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>
                      Common Postures And Movements That Can Lead To Injury
                    </h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_3 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_3 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less3 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Common Manual Handling Injuries</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_4 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_4 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less4 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Before Undertaking A Manual Handling Task</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_5 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_5 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less5 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>

                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Correct Lifting Techniques</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_6 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_6 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less6 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>

                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Final Assessment</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_9 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_9 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less9 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-grow-1 rightpart">
          {lesson1 && (
            <section id="introd" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  to={`/start-course/${id}`}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Home</h5>
                </Link>
                <div className="stop fixnav">
                  <button
                    type="button"
                    onClick={() => menubars()}
                    className="tbtn"
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 1 of 7</h4>
                      <h1>Introduction</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>

                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                    >
                      <h5>Background Information:</h5>
                      <p>
                        Statistics indicate that manual handling contributes to
                        more than one-third of workplace injuries and is
                        responsible for over 60% of severe workers' compensation
                        claims in Australia. These injuries predominantly
                        comprise work-related musculoskeletal disorders (MSDs),
                        which encompass injuries or diseases affecting the
                        musculoskeletal system, whether they occur suddenly or
                        develop over time. Notably, these figures do not
                        encompass injuries resulting from crushing, entrapment,
                        or cutting due to machinery operation.
                      </p>
                      <h5 className="text-center">
                        Data on Percentage of Serious Claims by Mechanism of
                        Injury or Disease, 2017-2018:
                      </h5>
                      <p className="text-center">
                        <span>(Source: SafeWork Australia)</span>
                      </p>
                      <div className="d-block ">
                        <img
                          className="w-100"
                          src={require("../assets/ohs/images/Introduction-Manual-Handling.png")}
                          alt="img"
                        />
                      </div>
                      <p>Examples of MSDs include:</p>
                      <ul className="d-flex flex-column gap-3">
                        <li>
                          <p>
                            Sprains and strains of muscles, ligaments, and
                            tendons.
                          </p>
                        </li>
                        <li>
                          <p>
                            Back injuries, encompassing damage to muscles,
                            tendons, ligaments, spinal discs, nerves, joints,
                            and bones.
                          </p>
                        </li>
                        <li>
                          <p>
                            Joint and bone injuries or degeneration, covering
                            injuries to the shoulder, elbow, wrist, hip, knee,
                            ankle, hands, and feet.
                          </p>
                        </li>
                        <li>
                          <p>
                            Nerve injuries or compression, such as carpal tunnel
                            syndrome.
                          </p>
                        </li>
                        <li>
                          <p>
                            Muscular and vascular disorders resulting from
                            hand-arm vibration.
                          </p>
                        </li>
                        <li>
                          <p>Soft tissue injuries, including hernias.</p>
                        </li>
                        <li>
                          <p>Chronic pain.</p>
                        </li>
                      </ul>
                      <p>
                        The statistical evidence highlights a significant
                        increase in the median lost time for such injuries.
                      </p>
                      <p>
                        Consequently, manual handling and MSDs are a focal point
                        for health and safety regulators, with various
                        strategies being developed in collaboration with
                        government agencies, industry stakeholders, unions, and
                        the general public.
                      </p>
                      <h5>What Is Manual Handling?</h5>
                      <p>
                        Manual handling typically involves the transportation or
                        support of a load, including actions like lifting,
                        putting down, pushing, pulling, carrying, or moving by
                        hand or bodily force.
                      </p>
                      <p>
                        A hazardous manual handling task involves activities
                        such as lifting, lowering, pushing, pulling, carrying,
                        or moving objects, people, or animals, and may include
                        one or more of the following:
                      </p>
                      <ul className="d-flex flex-column gap-3">
                        <li>
                          <p>Repetitive or sustained force.</p>
                        </li>
                        <li>
                          <p>High or sudden force.</p>
                        </li>
                        <li>
                          <p>Repetitive movements.</p>
                        </li>
                        <li>
                          <p>Sustained or awkward postures.</p>
                        </li>
                        <li>
                          <p>Exposure to vibration.</p>
                        </li>
                      </ul>
                      <h5>Manual Handling Examples</h5>
                      <p>
                        Drag and sort the below tasks into the correct boxes:
                      </p>

                      <div className="d-block  btn-block  text-center py-5">
                        <button type="button" onClick={() => nextStep("1")}>
                          CONTINUE
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson2 && (
            <section id="legislation" className="intro w-100">
              <div className="d-flex flex-column" ref={st2}>
                <Link
                  to="#introd"
                  onClick={() => backlesson("2")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 1 - Introduction</h5>
                </Link>
                <div className="stop fixnav">
                  <button
                    type="button"
                    onClick={() => menubars()}
                    className="tbtn"
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 2 of 7</h4>
                      <h1>Legislation</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>

                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                    >
                      <p>
                        The overarching goal of health and safety legislation
                        concerning manual handling and MSDs is to:
                      </p>
                      <ul className="d-flex flex-column gap-3">
                        <li>
                          <p>
                            Eliminate the necessity for employees to engage in
                            manual handling tasks posing injury risks.
                          </p>
                        </li>
                        <li>
                          <p>
                            Where elimination isn't feasible, implement control
                            measures to minimize the risks of manual handling
                            injuries to the extent that is reasonably practical.
                          </p>
                        </li>
                      </ul>

                      <div className="d-flex flex-column align-items-center py-3 py-md-5 health-safety">
                        <div className="health d-flex flex-column gap-4">
                          <div className="d-flex flex-column gap-2">
                            <h3>Health And Safety Legislation</h3>
                            <p>
                              Health and safety legislation outlines the
                              comprehensive responsibilities pertaining to
                              health and safety, including those held by:
                            </p>
                            <ul>
                              <li>
                                <p>Employers.</p>
                              </li>
                              <li>
                                <p>Employees.</p>
                              </li>
                              <li>
                                <p>
                                  Manufacturers, designers, suppliers, and
                                  installers.
                                </p>
                              </li>
                              <li>
                                <p>
                                  Other individuals present at the workplace.
                                </p>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="s-line"></div>
                        <div className="health d-flex flex-column gap-4">
                          <div className="d-flex flex-column gap-2">
                            <h3>Responsibilities of Employers:</h3>
                            <p>
                              According to health and safety regulations,
                              employers are mandated to address the risks
                              associated with manual handling injuries through a
                              comprehensive risk management program.
                            </p>
                            <p>Employers are required to:</p>
                            <ul className="d-flex flex-column  gap-3">
                              <li>
                                <p>Identify manual handling hazards.</p>
                              </li>
                              <li>
                                <p>
                                  Identify foreseeable risks linked to these
                                  hazards.
                                </p>
                              </li>
                              <li>
                                <p>
                                  Assess the likelihood of injuries occurring.
                                </p>
                              </li>
                              <li>
                                <p>Implement appropriate control measures.</p>
                              </li>
                              <li>
                                <p>
                                  Evaluate and periodically review these control
                                  measures.
                                </p>
                              </li>
                            </ul>
                            <p>
                              These actions should be conducted in collaboration
                              with employees and other individuals involved in
                              manual handling tasks. Employers should
                              particularly ensure compliance when:
                            </p>
                            <ul className="d-flex flex-column  gap-3">
                              <li>
                                <p>
                                  Introducing new tasks or modifying existing
                                  ones.
                                </p>
                              </li>
                              <li>
                                <p>Selecting new equipment.</p>
                              </li>
                              <li>
                                <p>
                                  Undertaking renovations, refurbishments, or
                                  redesigning of workplaces.
                                </p>
                              </li>
                              <li>
                                <p>
                                  Engaging in work activities in new
                                  environments.
                                </p>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="s-line"></div>
                        <div className="health d-flex flex-column gap-4">
                          <div className="d-flex flex-column gap-2">
                            <h3>Responsibilities of Employees:</h3>
                            <p>Employees are obligated to:</p>
                            <ul className="d-flex flex-column  gap-3">
                              <li>
                                <p>
                                  Take responsibility for their own safety and
                                  the safety of others impacted by their actions
                                  or inactions.
                                </p>
                              </li>
                              <li>
                                <p>
                                  Collaborate with the employer to adhere to the
                                  stipulations of the legislation.
                                </p>
                              </li>
                              <li>
                                <p>
                                  Adhere to any established safe work systems or
                                  procedures.
                                </p>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="s-line"></div>
                        <div className="health d-flex flex-column gap-4">
                          <div className="d-flex flex-column gap-2">
                            <h3>
                              Manufacturers, Designers, Suppliers, and
                              Installers:
                            </h3>
                            <p>
                              Those involved in designing, manufacturing,
                              importing, installing, and supplying plant and
                              structures bear the responsibility to ensure that
                              their products pose no risks to health and safety
                              when used correctly.
                            </p>
                            <p>This obligation encompasses:</p>
                            <ul className="d-flex flex-column  gap-3">
                              <li>
                                <p>
                                  Conducting thorough testing of the product.
                                </p>
                              </li>
                              <li>
                                <p>
                                  Ensuring that adequate information is
                                  communicated throughout the supply chain to
                                  mitigate manual handling risks to the greatest
                                  extent feasible.
                                </p>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="s-line"></div>
                        <div className="health d-flex flex-column gap-4">
                          <div className="d-flex flex-column gap-2">
                            <h3>Other Individuals at the Workplace:</h3>
                            <p>
                              This category comprises visitors and members of
                              the general public, who also share responsibility
                              to:
                            </p>
                            <ul className="d-flex flex-column  gap-3">
                              <li>
                                <p>
                                  Exercise reasonable care for their own safety
                                  and the safety of others.
                                </p>
                              </li>
                              <li>
                                <p>
                                  Adhere to any reasonable instructions provided
                                  by the employer.
                                </p>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="d-block  btn-block  text-center py-5">
                        <button type="button" onClick={() => nextStep("2")}>
                          CONTINUE
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson3 && (
            <section id="common" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={third}
                  to="#legislation"
                  onClick={() => backlesson("3")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 2 - Legislation</h5>
                </Link>
                <div className="stop fixnav">
                  <button
                    type="button"
                    onClick={() => menubars()}
                    className="tbtn"
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 3 of 7</h4>
                      <h1>
                        Common Postures And Movements That Can Lead To Injury
                      </h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                    >
                      <p>
                        <span>Source: SafeWork Australia</span>
                      </p>
                      <h5>
                        Bending The Back or Head Forwards or Sideways More Than
                        20 Degrees
                      </h5>
                      <div
                        id="legal"
                        className="d-flex flex-column padding gap-3 py-3 introdu"
                      >
                        <div id="carouselExample" className="carousel slide ">
                          <div className="carousel-inner">
                            <Slider {...settings_1}>
                              <div className="carousel-item active">
                                <div className="silder-box1 d-flex flex-column gap-2 justify-content-center align-items-center text-center gap-1 py-5">
                                  <img
                                    className="w-100"
                                    src={require("../assets/ohs/images/20deg.png")}
                                    alt="imagae"
                                  />
                                </div>
                              </div>
                              <div className="carousel-item">
                                <div className="silder-box2 d-flex flex-column gap-3">
                                  <img
                                    className="w-100"
                                    src={require("../assets/ohs/images/20deg1.png")}
                                    alt="image"
                                  />
                                </div>
                              </div>
                            </Slider>
                          </div>
                        </div>
                      </div>
                      <h5>
                        Bending The Back Or Head Backwards More Than 5 Degrees
                      </h5>
                      <div className="d-block">
                        <img
                          className="w-100"
                          src={require("../assets/ohs/images/50deg.png")}
                          alt="img"
                        />
                      </div>
                      <h5>Twisting The Back Or Neck More Than 20 Degrees</h5>
                      <div
                        id="legal"
                        className="d-flex flex-column padding gap-3 py-3 introdu"
                      >
                        <div id="carouselExampl" className="carousel slide ">
                          <div className="carousel-inner">
                            <Slider {...settings_2}>
                              <div className="carousel-item active">
                                <div className="silder-box1 d-flex flex-column gap-2 justify-content-center align-items-center text-center gap-1 py-5">
                                  <img
                                    className="w-100"
                                    src={require("../assets/ohs/images/202deg.png")}
                                    alt="imagae"
                                  />
                                </div>
                              </div>
                              <div className="carousel-item">
                                <div className="silder-box2 d-flex flex-column gap-3">
                                  <img
                                    className="w-100"
                                    src={require("../assets/ohs/images/203deg.png")}
                                    alt="image"
                                  />
                                </div>
                              </div>
                            </Slider>
                          </div>
                        </div>
                      </div>
                      <h5>
                        Working With One Or Both Hands Above The Shoulder Height
                      </h5>
                      <div className="d-block">
                        <img
                          className="w-100"
                          src={require("../assets/ohs/images/solder.png")}
                          alt="img"
                        />
                      </div>
                      <div className="d-block  btn-block  text-center py-5">
                        <button type="button" onClick={() => nextStep("3")}>
                          CONTINUE
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson4 && (
            <section id="manual" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={forth}
                  to="#common"
                  onClick={() => backlesson("4")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>
                    Lesson 3 - Common Postures And Movements That Can Lead To
                    Injury
                  </h5>
                </Link>
                <div className="stop fixnav">
                  <button
                    type="button"
                    onClick={() => menubars()}
                    className="tbtn"
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 4 of 7</h4>
                      <h1>Common Manual Handling Injuries</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                    >
                      <h6 className="text-center">
                        Numerous injuries linked with manual handling involve
                        lower back pain and upper limb disorders (ULDs).
                      </h6>
                      <h6 className="text-center">
                        The subsequent section furnishes information regarding
                        the various types of injuries that may occur during the
                        execution of manual handling tasks.
                      </h6>
                      <div className="py-3 d-flex justify-content-center align-items-center bg-light">
                        <div
                          className="card card-1 p-0 shadow"
                          style={{ maxWidth: "100%" }}
                        >
                          <nav>
                            <div
                              className="nav nav-tabs mb-3 nav-fill"
                              id="nav-tab1"
                              role="tablist"
                            >
                              <button
                                className={`nav-link  ${Tab33_1 === "Tab1" ? "active " : ""
                                  } `}
                                id="nav-home-tab1"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-home1"
                                type="button"
                                role="tab"
                                aria-controls="nav-home"
                                aria-selected="true"
                                onClick={() => tabReview_33("Tab1")}
                              >
                                Short -Term / Superficial Injuries
                              </button>
                              <button
                                className={`nav-link  ${Tab33_2 === "Tab2" ? "active " : ""
                                  } `}
                                id="nav-profile-tab2"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-profile2"
                                type="button"
                                role="tab"
                                aria-controls="nav-profile"
                                aria-selected="false"
                                tabindex="-1"
                                onClick={() => tabReview_33("Tab2")}
                              >
                                Long–Term Injuries
                              </button>
                            </div>
                          </nav>
                          <div
                            className="tab-content p-4 bg-light"
                            id="nav-tabContent"
                          >
                            {Tab33_1 && (
                              <div
                                className="tab-pane fade active show"
                                id="nav-home1"
                                role="tabpanel"
                                aria-labelledby="nav-home-tab1"
                              >
                                <div className="d-flex flex-column gap-3">
                                  <p>
                                    As an illustration, injuries such as cuts,
                                    bruises, sprains, tears, small fractures,
                                    and muscle strain often result from sudden
                                    and unforeseen incidents. These incidents
                                    might include losing grip and dropping a
                                    load, lifting an excessively heavy object at
                                    an awkward angle, or stumbling while
                                    carrying a load.
                                  </p>
                                  <div className="d-block">
                                    <img
                                      src={require("../assets/ohs/images/short-term.jpg")}
                                      alt="image"
                                    />
                                  </div>
                                  <p>
                                    These conditions are referred to as
                                    musculoskeletal disorders and constitute a
                                    significant portion of all severe claims
                                    related to MSDs.
                                  </p>
                                </div>
                              </div>
                            )}
                            {Tab33_2 && (
                              <div
                                className="tab-pane fade show active"
                                id="nav-profile2"
                                role="tabpanel"
                                aria-labelledby="nav-profile-tab2"
                              >
                                <div className="d-flex flex-column gap-3">
                                  <p>
                                    Primarily, these entail harm to the
                                    musculoskeletal system of the body,
                                    encompassing muscles, tendons, bones,
                                    joints, ligaments, nerves, and blood
                                    vessels. Such damage typically arises from
                                    prolonged, gradual wear-and-tear due to
                                    repetitive strenuous activities or improper
                                    handling techniques.
                                  </p>
                                  <div className="d-block">
                                    <img
                                      src={require("../assets/ohs/images/long-term.jpg")}
                                      alt="image"
                                    />
                                  </div>
                                  <p>
                                    These conditions, categorized as
                                    musculoskeletal disorders, constitute a
                                    significant portion of all severe claims
                                    related to MSDs.
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <h5>Injuries from Physical Overexertion</h5>
                      <p>
                        Physical overexertion frequently leads to injuries,
                        often triggered by repetitive motions like lifting heavy
                        objects or working in awkward positions.
                      </p>
                      <p>
                        Such injuries commonly result in acute pain, and if left
                        untreated, they can escalate into chronic pain and
                        long-term complications, such as carpal tunnel syndrome
                        and osteoarthritis.
                      </p>
                      <div className="d-block">
                        <img
                          className="w-100"
                          src={require("../assets/ohs/images/over.jpg")}
                          alt="image"
                        />
                      </div>
                      <h5>Understanding Manual Handling Injuries</h5>
                      <p>
                        To comprehend the root cause of most manual handling
                        injuries, it's crucial to grasp the anatomy of the
                        spine.
                      </p>
                      <p>The spine serves three primary functions:</p>
                      <div className="d-flex flex-column gap-3">
                        <div className="d-flex align-items-center gap-5">
                          <div className="no">
                            <p>1</p>
                          </div>
                          <p>To safeguard the spinal cord.</p>
                        </div>
                        <div className="d-flex align-items-center gap-5">
                          <div className="no">
                            <p>2</p>
                          </div>
                          <p>To facilitate movement.</p>
                        </div>
                        <div className="d-flex align-items-center gap-5">
                          <div className="no">
                            <p>3</p>
                          </div>
                          <p>To provide support to the upper body.</p>
                        </div>
                      </div>
                      <p>
                        As the primary support structure for the body, the spine
                        is vulnerable to damage from improper movements and
                        handling techniques. Any damage to the spine can have
                        cascading effects on the rest of the body.
                      </p>
                      <div className="row align-items-center pt-3">
                        <div className="col-lg-6">
                          <div className="d-block">
                            <img
                              className="w-100"
                              src={require("../assets/ohs/images/spim.jpg")}
                              alt="img"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="d-flex flex-column gap-3">
                            <p>
                              In human anatomy, the vertebral column, also known
                              as the backbone or spine, typically comprises 33
                              vertebrae, along with the sacrum, intervertebral
                              discs, and the coccyx. Positioned in the dorsal
                              aspect of the torso, these components are
                              separated by spinal discs.
                            </p>
                            <p>
                              The vertebral column serves to house and safeguard
                              the spinal cord within its spinal canal.
                            </p>
                          </div>
                        </div>
                      </div>
                      <h5>The Human Spine</h5>
                      <div className="position-relative">
                        <div className="d-block">
                          <img
                            className="w-100"
                            src={require("../assets/ohs/images/sliped.png")}
                            alt="img"
                          />
                        </div>
                        {!dot1 ? (
                          <div
                            className="onclick-dot bg-red"
                            onClick={() => bodypart("1")}
                          >
                            <i className="fas fa-exclamation"></i>
                          </div>
                        ) : (
                          <div
                            className="onclick-dot  active-red "
                            onClick={() => bodypart("1")}
                          >
                            <i className="fas fa-exclamation"></i>
                          </div>
                        )}

                        {!dot2 ? (
                          <div
                            class="onclick-dot1 bg-red"
                            onClick={() => bodypart("2")}
                          >
                            <i class="fas fa-exclamation"></i>
                          </div>
                        ) : (
                          <div
                            class="onclick-dot1 active-red"
                            onClick={() => bodypart("2")}
                          >
                            <i class="fas fa-exclamation"></i>
                          </div>
                        )}
                        {!dot3 ? (
                          <div
                            className="onclick-dot2 bg-red"
                            onClick={() => bodypart("3")}
                          >
                            <i className="fas fa-exclamation"></i>
                          </div>
                        ) : (
                          <div
                            className="onclick-dot2 active-red"
                            onClick={() => bodypart("3")}
                          >
                            <i className="fas fa-exclamation"></i>
                          </div>
                        )}

                        {section3_content && (
                          <div className="safe-info4 d-block">
                            <div className="safe-please position-relative d-flex flex-column  gap-3">
                              <div className="d-flex justify-content-between ">
                                <h5>{title3}</h5>
                              </div>
                              <p>
                                <strong>{param_title3}</strong> {param3}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="row align-items-center pt-3">
                        <div className="col-lg-6">
                          <div className="d-block">
                            <img
                              className="w-100"
                              src={require("../assets/ohs/images/spinal.png")}
                              alt="img"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="d-flex flex-column gap-3">
                            <p>
                              This happens when the disc fractures, permitting
                              the nucleus to leak out near the spinal nerve.
                              This exerts pressure on the nerves, leading to
                              intense pain.
                            </p>
                            <p>
                              Typically, this is attributed to prolonged poor
                              handling techniques rather than a singular event.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="d-block  btn-block  text-center py-5">
                      <button type="button" onClick={() => nextStep("4")}>
                        CONTINUE
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson5 && (
            <section id="undertaking" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={fifth}
                  to="#manual"
                  onClick={() => backlesson("5")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 4 - Common Manual Handling Injuries</h5>
                </Link>
                <div className="stop fixnav">
                  <button
                    type="button"
                    onClick={() => menubars()}
                    className="tbtn"
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 5 of 7</h4>
                      <h1>Before Undertaking A Manual Handling Task</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>

                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                    >
                      <div
                        id="carouselExample1"
                        className="carousel slide py-5"
                      >
                        <div className="carousel-inner">
                          <Slider {...settings_3}>
                            <div className="carousel-item active">
                              <div className="silder-box2 d-flex flex-column gap-3">
                                <div className="steps">
                                  <Link to="#">Step 1</Link>
                                </div>
                                <h1 className="py-2">Why Move The Load?</h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      className="w-100"
                                      src={require("../assets/ohs/images/box.jpg")}
                                      alt="..."
                                    />
                                  </div>
                                </div>

                                <p>
                                  Reflect on the reason for relocating the load,
                                  such as transferring it from a storage
                                  facility to a required area, or delivering
                                  stock to a shop or office.
                                </p>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="silder-box2 d-flex flex-column gap-3">
                                <div className="steps">
                                  <Link to="#">Step 2</Link>
                                </div>
                                <h1 className="py-2">
                                  Consider How Best To Carry Out The Task
                                </h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      src={require("../assets/ohs/images/teask.png")}
                                      className="d-block w-100"
                                      alt="img"
                                    />
                                  </div>
                                </div>
                                <p>
                                  Examine every aspect of how the load will be
                                  handled and assess any areas that might
                                  necessitate additional control measures to
                                  mitigate risks. The upcoming slides will aid
                                  in understanding this aspect and guide you on
                                  the relevant questions to consider.
                                </p>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="silder-box2">
                                <div className="steps">
                                  <Link to="#">Step 3</Link>
                                </div>
                                <h1 className="py-2">
                                  Who Needs To Be Involved?
                                </h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      src={require("../assets/ohs/images/invol.jpg")}
                                      className="d-block w-100"
                                      alt="img"
                                    />
                                  </div>
                                </div>
                                <p>
                                  Evaluate which employees are tasked with
                                  moving the load, engage in discussions with
                                  the involved employees, and solicit their
                                  feedback on the process.
                                </p>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="silder-box2">
                                <div className="steps">
                                  <Link to="#">Step 4</Link>
                                </div>
                                <h1 className="py-2">
                                  Are Any Manual Handling Aids Needed To Perform
                                  The Task?
                                </h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      src={require("../assets/ohs/images/hrlp.jpg")}
                                      className="d-block w-100"
                                      alt="img"
                                    />
                                  </div>
                                </div>
                                <p>
                                  Certain loads may necessitate the use of
                                  supplementary manual handling aids, such as
                                  trolleys, slings, or mechanical lifts.
                                </p>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="silder-box2">
                                <div className="steps">
                                  <Link to="#">Step 5</Link>
                                </div>
                                <h1 className="py-2">
                                  Where Is The Load Going?
                                </h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      src={require("../assets/ohs/images/need-help.jpg")}
                                      className="d-block w-100"
                                      alt="img"
                                    />
                                  </div>
                                </div>
                                <p>
                                  Determine the origin of the load and the route
                                  it will be taken, considering any potential
                                  obstructions or areas that might heighten
                                  risks to employees.
                                </p>
                                <p>
                                  Walk along the designated route to inspect for
                                  hazards.
                                </p>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="silder-box2">
                                <div className="steps">
                                  <Link to="#">Step 6</Link>
                                </div>
                                <h1 className="py-2">
                                  How Quickly Does The Task Need To Be Carried
                                  Out?
                                </h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      src={require("../assets/ohs/images/box2.jpg")}
                                      className="d-block w-100"
                                      alt="img"
                                    />
                                  </div>
                                </div>

                                <p>
                                  Is there a time constraint for moving the
                                  load? Is there sufficient time allocated to
                                  accomplish the task effectively?
                                </p>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="silder-box2">
                                <div className="steps">
                                  <Link to="#">Step 7</Link>
                                </div>
                                <h1 className="py-2">
                                  How Often Does The Task Occur?
                                </h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      src={require("../assets/ohs/images/need-h2.jpg")}
                                      className="d-block w-100"
                                      alt="img"
                                    />
                                  </div>
                                </div>
                                <p>
                                  The frequency of handling the load can impact
                                  the risk of injury; frequent handling may lead
                                  to repetitive strain injuries.
                                </p>
                              </div>
                            </div>
                          </Slider>
                        </div>
                      </div>
                      <div className="d-block  btn-block  text-center pb-5">
                        <button type="button" onClick={() => nextStep("5")}>
                          CONTINUE
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson6 && (
            <section id="lifting" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={sixth}
                  to="#undertaking"
                  onClick={() => backlesson("6")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 5 - Before Undertaking A Manual Handling Task</h5>
                </Link>
                <div className="stop fixnav">
                  <button
                    type="button"
                    onClick={() => menubars()}
                    className="tbtn"
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 6 of 7</h4>
                      <h1>Correct Lifting Techniques</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>

                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                    >
                      <div
                        id="carouselExample2"
                        className="carousel slide py-5"
                      >
                        <div className="carousel-inner">
                          <Slider {...settings_4}>
                            <div className="carousel-item active">
                              <div className="silder-box1 d-flex flex-column gap-2 justify-content-center align-items-center text-center gap-1 py-5">
                                <h5>Introduction</h5>
                                <p>
                                  Prior to engaging in any manual handling task,
                                  it is crucial to comprehend proper manual
                                  handling techniques and only undertake tasks
                                  within your capability to perform safely.
                                </p>

                                {/* <Link to="#" className="ss1-btn">
                                  <p href="#">Start</p>
                                </Link> */}
                              </div>
                            </div>
                            <div className="carousel-item ">
                              <div className="silder-box2 d-flex flex-column gap-3">
                                <div className="steps">
                                  <Link to="#">Step 1</Link>
                                </div>
                                <h1 className="py-2 text-center">
                                  Stop & Think
                                </h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      className="w-100"
                                      src={require("../assets/ohs/images/pos1.png")}
                                      alt="..."
                                    />
                                  </div>
                                </div>

                                <p>
                                  Plan tasks involving manual handling.
                                  Determine the weight of the load and its
                                  intended placement. Utilize suitable handling
                                  aids whenever feasible. Assess if assistance
                                  will be needed.
                                </p>
                                <p>
                                  Clear obstructions, like discarded wrapping
                                  materials. For extended lifts, like from the
                                  floor to shoulder height, contemplate resting
                                  the load midway on a table or bench to alter
                                  the grip.
                                </p>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="silder-box2 d-flex flex-column gap-3">
                                <div className="steps">
                                  <Link to="#">Step 2</Link>
                                </div>
                                <h1 className="py-2 text-center">
                                  Adopt A Stable Position
                                </h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      src={require("../assets/ohs/images/pos2.png")}
                                      className="d-block w-100"
                                      alt="img"
                                    />
                                  </div>
                                </div>
                                <p>
                                  Stand with your feet apart, with one leg
                                  slightly forward to ensure balance (aligned
                                  with the load if it's on the ground).
                                </p>
                                <p>
                                  Be ready to adjust your feet during the lift
                                  to uphold a stable posture. Avoid wearing
                                  overly tight clothing or inappropriate
                                  footwear as they may impede the task.
                                </p>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="silder-box2">
                                <div className="steps">
                                  <Link to="#">Step 3</Link>
                                </div>
                                <h1 className="py-2 text-center">
                                  Ensure A Good Hold On The Load
                                </h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      src={require("../assets/ohs/images/pos3.png")}
                                      className="d-block w-100"
                                      alt="img"
                                    />
                                  </div>
                                </div>
                                <p>
                                  Whenever feasible, keep the load as close to
                                  your body as possible. Utilize any handles or
                                  devices already attached to the load. Maintain
                                  the load's balance.
                                </p>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="silder-box2">
                                <div className="steps">
                                  <Link to="#">Step 4</Link>
                                </div>
                                <h1 className="py-2 text-center">
                                  Keep The Load Close
                                </h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      src={require("../assets/ohs/images/pos4.png")}
                                      className="d-block w-100"
                                      alt="img"
                                    />
                                  </div>
                                </div>
                                <p>
                                  During lifting, endeavor to keep the load
                                  close to your waist for as long as possible.
                                  The distance between the load and the spine at
                                  waist height significantly impacts the overall
                                  strain on the spine and back muscles.
                                </p>
                                <p>
                                  Position the heaviest side of the load next to
                                  your body. If it's not feasible to approach
                                  the load closely, attempt to slide it towards
                                  your body before lifting.
                                </p>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="silder-box2">
                                <div className="steps">
                                  <Link to="#">Step 5</Link>
                                </div>
                                <h1 className="py-2 text-center">
                                  Keep Your Back Straight
                                </h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      src={require("../assets/ohs/images/pos5.png")}
                                      className="d-block w-100"
                                      alt="img"
                                    />
                                  </div>
                                </div>
                                <p>
                                  It's preferable to slightly bend your back and
                                  knees at the beginning of the lift rather than
                                  fully flexing the back (stooping) or fully
                                  flexing the hips and knees (deep squatting).
                                  However, avoid this posture whenever possible.
                                </p>
                                <p>Do not bend any further while lifting!</p>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="silder-box2">
                                <div className="steps">
                                  <Link to="#">Step 6</Link>
                                </div>
                                <h1 className="py-2 text-center">
                                  Avoid Twisting Or Leaning Sideways
                                </h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      src={require("../assets/ohs/images/pos6.png")}
                                      className="d-block w-100"
                                      alt="img"
                                    />
                                  </div>
                                </div>
                                <p>
                                  Avoid twisting your back or leaning sideways,
                                  especially when your back is bent. Keep your
                                  shoulders level and facing the same direction
                                  as your hips. It's better to turn by moving
                                  your feet rather than twisting and lifting
                                  simultaneously.
                                </p>
                              </div>
                            </div>
                            <div className="carousel-item ">
                              <div className="silder-box1 d-flex flex-column gap-2 justify-content-center align-items-center text-center gap-1 py-5">
                                <h5>Summary</h5>
                                <p>
                                  In summary, this approach should be applied to
                                  all manual handling tasks, whenever possible
                                  and appropriate considering the load and
                                  environment.
                                </p>
                                {/* <div className="d-block">
                                  <Link
                                    to=""
                                    className="d-flex flex-column gap-2"
                                    href="#"
                                  >
                                    <span>START AGAIN</span>
                                    <i className="fal fa-redo"></i>
                                  </Link>
                                </div> */}
                              </div>
                            </div>
                          </Slider>
                        </div>
                      </div>
                      <div className="d-block  btn-block  text-center pb-5">
                        <button type="button" onClick={() => nextStep("6")}>
                          CONTINUE
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson9 && (
            <section id="assessment" className="human w-100">
              <div className="d-flex flex-column">
                <Link
                  to="#respond"
                  onClick={() => backlesson("9")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 6-Fire and Explosion Risks</h5>
                </Link>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 7 of 7</h4>
                      <h1>Final Assessment</h1>
                      <div className="line" style={{ width: "100%" }}></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <form action="javascript:void(0)">
                    <div className="col-lg-10 offset-md-1 padding py-5">
                      {sec_1 && (
                        <div className="d-flex flex-column gap-5 fullname-block text-center py-5">
                          <h4>
                            Please enter your FULL NAME before you continue:
                          </h4>
                          <div className="d-flex justify-content-center name-form">
                            <div className="d-flex gap-2">
                              <div className="flex-grow-1">
                                <input
                                  type="text"
                                  name=""
                                  id=""
                                  required
                                  onInput={entername_9}
                                  ref={inputRef}
                                  placeholder="Type your name here..."
                                />
                              </div>
                              <div className="flex-shrink-0">
                                <button type="submit" onClick={btn_entername}>
                                  Continue
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {quizless_9_1 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>
                            Guidance on manual handling operations state that:
                          </h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check ${isOpacity_9 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q1"
                                  id="A certain"
                                  checked={checkQ_9_1 === "A certain"}
                                  onChange={() => startQuiz_9_1("A certain")}
                                />
                                {isfirstquiz_9_1 &&
                                  (issetQuizAns_9_1_btn === "A certain" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="A certain"
                              >
                                A certain amount that is safe for a person to
                                lift
                              </label>
                            </div>

                            <div
                              className={`form-check ${isOpacity_9 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q1"
                                  id="An employee"
                                  checked={checkQ_9_1 === "An employee"}
                                  onChange={() => startQuiz_9_1("An employee")}
                                />
                                {isfirstquiz_9_1 &&
                                  (issetQuizAns_9_1_btn === "An employee" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="An employee"
                              >
                                An employee should try to lift only as much as
                                they are able to
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q1"
                                  id="Two people"
                                  checked={checkQ_9_1 === "Two people"}
                                  onChange={() => startQuiz_9_1("Two people")}
                                />
                                {isfirstquiz_9_1 &&
                                  (issetQuizAns_9_1_btn === "Two people" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Two people"
                              >
                                Two people can lift twice as much as one
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q1"
                                  id="The maximum"
                                  checked={checkQ_9_1 === "The maximum"}
                                  onChange={() => startQuiz_9_1("The maximum")}
                                />
                                {isfirstquiz_9_1 &&
                                  (issetQuizAns_9_1_btn === "The maximum" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="The maximum"
                              >
                                The maximum weight to be lifted is 25kg
                              </label>
                            </div>

                            {worngansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q1_9_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next_9("1")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_1_9 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_9("1")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {quizless_9_2 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>
                            When undertaking a manual handling task, which of
                            the following statements is true?
                          </h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check  ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q2"
                                  id="You should"
                                  checked={checkQ_9_2 === "You should"}
                                  onChange={() => startQuiz_9_2("You should")}
                                />
                                {isfirstquiz_9_2 &&
                                  (issetQuizAns_9_2_btn === "You should" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="You should"
                              >
                                You should always keep your back bent whilst
                                lifting
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q2"
                                  id="Loads should"
                                  checked={checkQ_9_2 === "Loads should"}
                                  onChange={() => startQuiz_9_2("Loads should")}
                                />
                                {isfirstquiz_9_2 &&
                                  (issetQuizAns_9_2_btn === "Loads should" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Loads should"
                              >
                                Loads should be held at arm's length whilst
                                carrying
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q2"
                                  id="Anyone can"
                                  checked={checkQ_9_2 === "Anyone can"}
                                  onChange={() => startQuiz_9_2("Anyone can")}
                                />
                                {isfirstquiz_9_2 &&
                                  (issetQuizAns_9_2_btn === "Anyone can" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Anyone can"
                              >
                                Anyone can carry any load as long as they are
                                strong enough
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q2"
                                  id="Large loads"
                                  checked={checkQ_9_2 === "Large loads"}
                                  onChange={() => startQuiz_9_2("Large loads")}
                                />
                                {isfirstquiz_9_2 &&
                                  (issetQuizAns_9_2_btn === "Large loads" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Large loads"
                              >
                                Large loads should be broken into smaller loads
                                where possible
                              </label>
                            </div>
                            {worngansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q2_9_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next_9("2")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_2_9 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_9("2")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {quizless_9_3 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>Before lifting you should:</h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q3"
                                  id="Plan and"
                                  checked={checkQ_9_3 === "Plan and"}
                                  onChange={() => startQuiz_9_3("Plan and")}
                                />
                                {isfirstquiz_9_3 &&
                                  (issetQuizAns_9_3_btn === "Plan and" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Plan and"
                              >
                                Plan and assess the load
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q3"
                                  id="Look for"
                                  checked={checkQ_9_3 === "Look for"}
                                  onChange={() => startQuiz_9_3("Look for")}
                                />
                                {isfirstquiz_9_3 &&
                                  (issetQuizAns_9_3_btn === "Look for" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Look for"
                              >
                                Look for the risk assessment
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q3"
                                  id="Call for"
                                  checked={checkQ_9_3 === "Call for"}
                                  onChange={() => startQuiz_9_3("Call for")}
                                />
                                {isfirstquiz_9_3 &&
                                  (issetQuizAns_9_3_btn === "Call for" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Call for"
                              >
                                Call for help
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q3"
                                  id="All of"
                                  checked={checkQ_9_3 === "All of"}
                                  onChange={() => startQuiz_9_3("All of")}
                                />
                                {isfirstquiz_9_3 &&
                                  (issetQuizAns_9_3_btn === "All of" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="All of">
                                All of the above
                              </label>
                            </div>
                            {worngansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q3_9_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next_9("3")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_3_9 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_9("3")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {quizless_9_4 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>
                            Where a load has to be lifted manually, what is the
                            employer required to do by law?
                          </h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q4"
                                  id="Calculate"
                                  checked={checkQ_9_4 === "Calculate"}
                                  onChange={() => startQuiz_9_4("Calculate")}
                                />
                                {isfirstquiz_9_4 &&
                                  (issetQuizAns_9_4_btn === "Calculate" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Calculate"
                              >
                                Calculate the cost of the task
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q4"
                                  id="Assess"
                                  checked={checkQ_9_4 === "Assess"}
                                  onChange={() => startQuiz_9_4("Assess")}
                                />
                                {isfirstquiz_9_4 &&
                                  (issetQuizAns_9_4_btn === "Assess" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Assess">
                                Assess the risk of the task
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q4"
                                  id="Assess the"
                                  checked={checkQ_9_4 === "Assess the"}
                                  onChange={() => startQuiz_9_4("Assess the")}
                                />
                                {isfirstquiz_9_4 &&
                                  (issetQuizAns_9_4_btn === "Assess the" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Assess the"
                              >
                                Assess the time the job will take
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q4"
                                  id="Determine"
                                  checked={checkQ_9_4 === "Determine"}
                                  onChange={() => startQuiz_9_4("Determine")}
                                />
                                {isfirstquiz_9_4 &&
                                  (issetQuizAns_9_4_btn === "Determine" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Determine"
                              >
                                Determine the number of people required
                              </label>
                            </div>
                            {worngansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q4_9_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next_9("4")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_4_9 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_9("4")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {quizless_9_5 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>
                            If a load has an uneven centre of gravity, how
                            should you lift
                          </h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q5"
                                  id="Keeping"
                                  checked={checkQ_9_5 === "Keeping"}
                                  onChange={() => startQuiz_9_5("Keeping")}
                                />
                                {isfirstquiz_9_5 &&
                                  (issetQuizAns_9_5_btn === "Keeping" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Keeping">
                                Keeping the heaviest side of the load towards
                                you
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q5"
                                  id="Keeping the"
                                  checked={checkQ_9_5 === "Keeping the"}
                                  onChange={() => startQuiz_9_5("Keeping the")}
                                />
                                {isfirstquiz_9_5 &&
                                  (issetQuizAns_9_5_btn === "Keeping the" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Keeping the"
                              >
                                Keeping the heaviest side of the load away from
                                you
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q5"
                                  id="Keeping the heaviest"
                                  checked={
                                    checkQ_9_5 === "Keeping the heaviest"
                                  }
                                  onChange={() =>
                                    startQuiz_9_5("Keeping the heaviest")
                                  }
                                />
                                {isfirstquiz_9_5 &&
                                  (issetQuizAns_9_5_btn ===
                                    "Keeping the heaviest" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Keeping the heaviest"
                              >
                                Keeping the heaviest side of the load on your
                                strongest arm
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q5"
                                  id="Keeping the heaviest side"
                                  checked={
                                    checkQ_9_5 === "Keeping the heaviest side"
                                  }
                                  onChange={() =>
                                    startQuiz_9_5("Keeping the heaviest side")
                                  }
                                />
                                {isfirstquiz_9_5 &&
                                  (issetQuizAns_9_5_btn ===
                                    "Keeping the heaviest side" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Keeping the heaviest side"
                              >
                                Keeping the heaviest side of the load on your
                                weakest arm
                              </label>
                            </div>
                            {worngansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q5_9_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next_9("5")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_5_9 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_9("5")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {less_5_finresult && (
                        <div className="d-flex flex-column gap-3 text-center results-block">
                          <h3 className="text-danger">Results</h3>

                          <div className="row gy-3 gy-md-5">
                            <div className="col-lg-9">
                              <h3>
                                <b>Your Score:</b>
                              </h3>
                            </div>
                            <div className="col-lg-9">
                              <h3>
                                {score__per5}% ({score_5} points)
                              </h3>
                            </div>
                            <div className="col-lg-9">
                              <h3>
                                <b>Passing Score:</b>
                              </h3>
                            </div>
                            <div className="col-lg-9">
                              <h3>80% (40 points)</h3>
                            </div>
                            <div className="col-12">
                              {!corrScore && (
                                <h4 className="text-danger">
                                  <i className="far fa-times"></i> You did not
                                  pass
                                </h4>
                              )}
                              {corrScore && (
                                <h4 className="text-success">
                                  <i className="far fa-check check"></i> You
                                  pass
                                </h4>
                              )}
                            </div>
                            {!corrScore ? (
                              <div className="col-lg-">
                                <button type="button" onClick={refreshbtn}>
                                  Retry Assessment
                                </button>
                              </div>
                            ) : (
                              <div className="col-lg-">
                                <button type="button" onClick={downloadpdf}>
                                  Download
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </section>
          )}
        </div>
      </div>
    </>
  );
};
